import { ICON__copy_solid } from '@/assets/icons_fa';
import { UI_PRIMITIVE__button_with_icon_animated } from '@/components/ui/UI_PRIMITIVE__button_with_icon_animated';
import { use_hint_shortcut } from '@/hooks/hints_shortcut/use_hint_shortcut';
import { HOOK_IMAGE__copy_to_clipboard } from '@/hooks/image/HOOK_IMAGE__copy_to_clipboard';
import { use_slice_user } from '@/hooks/store/use_slices';
import { HOOK_GRID2D_CELL__button_size } from '@/pages/_base/grid2d_cell/_hooks/HOOK_GRID2D_CELL__button_size';
import { EVENT_NULL__mouse } from '@/types/types';
import { DTO__image_asset } from '@shared/dto/+image/image_asset_base/DTO__image_asset';
import { DTO__entity_with_grid2d } from '@shared/dto/+workspace/workspace_entity/_database_entity_with_grid2d_permissions/DTO__entity_with_grid2d';
import { ENUM__grid2d_cell_size } from '@shared/dto/grid2d_cell/ENUM__grid2d_cell_size';
import { EShortcutType } from '@shared/dto/hint_shortcuts/e_shortcut_type';

interface Props {
  image: DTO__image_asset;
  entity: DTO__entity_with_grid2d;
  wrapper_class_name: string;
}

export function BUTTON_GRID2D_IMAGE__copy_to_clipboard({ image, entity, wrapper_class_name }: Props) {
  const { user_settings } = use_slice_user(['user_settings']);

  const grid2d_cell_button_size = HOOK_GRID2D_CELL__button_size(user_settings.ui_grid2d_cell_size);

  const { on_user_uses_shortcut } = use_hint_shortcut(EShortcutType.GRID2D_CELL_BUTTON_COPY_TO_CLIPBOARD);

  const { copy_to_clipboard } = HOOK_IMAGE__copy_to_clipboard();

  /*
   * EVENTS
   */

  async function onClick(e: EVENT_NULL__mouse) {
    await copy_to_clipboard(image);

    on_user_uses_shortcut();
  }

  /*
   * EFFECTS
   */

  /*
   * METHODS
   */

  /*
   * RENDERS
   */

  return (
    <div className={wrapper_class_name}>
      <UI_PRIMITIVE__button_with_icon_animated
        Icon={ICON__copy_solid}
        iconClassNameHovered="!text-bar-foreground "
        iconClassNameBase={`!text-component-item-foreground !duration-300 !w-5 !h-5
             ${user_settings.ui_grid2d_cell_size === ENUM__grid2d_cell_size.L ? '!size-7' : ''}`}
        variant="no-border-on-component"
        size="square-10"
        {...{ onClick }}
        className={`cursor-pointer rounded-lg p-0 bg-bar
            ${grid2d_cell_button_size}`}
      />
    </div>
  );
}
